import { Violation } from '~/components/compliance/violationsFetcher';
import { ViolationFormData } from '~/components/uploadDocument/violationForm';
import { API_Compliance } from '~/data/schemas/compliance';

export const getDefaultViolationValues = (compliance: API_Compliance): ViolationFormData => ({
  isCarChangeable: false,
  carId: compliance.carId,
  propertyId: compliance.propertyId,
  code: '',
  location: '',
  correctionDue: '',
  dateOpen: '',
  responsibility: 'owner',
  description: '',
  severity: null,
});

// Nullable: a LOLER category C defect carries no correction deadline (CX-416).
const toDateInputValue = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  return dateStr.slice(0, 10);
};

export const getEditViolationValues = (
  compliance: API_Compliance,
  violation: Violation,
): ViolationFormData => ({
  isCarChangeable: false,
  carId: compliance.carId,
  propertyId: compliance.propertyId,
  code: violation.code ?? '',
  location: violation.location || '',
  correctionDue: toDateInputValue(violation.correctionDue),
  dateOpen: toDateInputValue(violation.dateOpen),
  responsibility: violation.responsibility,
  description: violation.description,
  // Wire value space is `enum | '' | null`; `|| null` collapses all three
  // empties to one `null`, matching `responsibility` above and the form's
  // schema (which rejects '' — only null or 'A'/'B'/'C').
  severity: violation.severity || null,
});
